import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useMemo, useState } from "react";
import { Chip, Grid, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { orderArrayV2 } from 'helpers/orderArray';

export const UnitsComponent = ({
  multi = false,
  state,
  dispatchAction = () => null,
  isWholesaler = false
}) => {
  const { unitsMap } = useSelector(({ unitsReducer }) => unitsReducer);
  const [mapUnit, setMapUnit] = useState([])
  const dispatch = useDispatch();

  useEffect(() => {
    if (state?.station?.id) {
      setMapUnit(unitsMap.filter(unit => unit?.idStation === state?.station?.id &&
        (unit.type.includes("ESTACIONARIO") || unit.type.includes("PORTATIL") || unit.type.includes("ESTACION") ||
          (isWholesaler && unit.type.includes("MAYORISTA")))
      ))
    }
    else{
      dispatch(dispatchAction("unit", null));
    }
  }, [state?.station]);

  const sortedUnits = useMemo(() => orderArrayV2(mapUnit, "label"), [mapUnit]);
  return (
    <Grid item xs={12} sm={3}>
      <Autocomplete
        id="combo-box-demo"
        options={sortedUnits}
        disabled={!state?.station?.name}
        value={multi ? [] || null : state?.unit || null}
        defaultValue={unitsMap[0] || null}
        getOptionLabel={option => option?.label || ""}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              label={option.label}
              {...getTagProps({ index })}
              style={{
                borderRadius: 4
              }}
            />
          ))
        }
        renderInput={params => (
          <TextField
            {...params}
            label="Unidad"
            variant="outlined"
            size="small"
          />
        )}
        fullWidth
        onChange={(e, v) => dispatch(dispatchAction("unit", v))}
        noOptionsText="No se encuentra la unidad"
        multiple={multi}
      />
    </Grid>
  );
};
